import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import ApiActions from 'go/actions/api';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {EmailInputForm} from 'app-ui-componentlibrary';
import AccountWrapper from '../AccountWrapper';
import {Alert} from 'componentLibrary';
import {API_ACC_RESET_PW_SUCCESS} from 'common/types';
import _ from 'lodash';

export class RequestPasswordReset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      formHasErrors: false,
      email: emptyStr,
      backendErrorMsg: false,
      recaptchaToken: emptyStr,
      recaptchaRef: {},
    };
  }

  componentDidMount() {
    const loginGovIntegrationPWDRemoval = _.includes(
      this.props.toggles,
      'passwordRemovalLoginGovIntegration'
    );

    if (loginGovIntegrationPWDRemoval) {
      this.navigateToLogin();
    }
  }

  setEmail = (email) =>
    this.setState({email, backendErrorMsg: false, formHasErrors: false});
  setFormHasErrors = () => this.setState({formHasErrors: true});
  openModal = () => this.setState({modalOpen: true});

  closeModal = () => this.setState({modalOpen: false});

  handleRecaptchaChange = (recaptchaRef, response) =>
    this.setState({
      recaptchaRef: recaptchaRef,
      recaptchaToken: response,
    });

  navigateToLogin = () => {
    this.closeModal();
    this.props.navigateToLogin();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({backendErrorMsg: false});
    const response = this.props.onSubmit(this.state.email.toLowerCase());
    response.then((res) => {
      this.handleResponseFromServer(res);
    });
  };

  setBackendErrorMsg = () => {
    this.setState({
      backendErrorMsg: true,
    });
  };

  handleResponseFromServer = (res) => {
    if (res !== undefined && res.type === API_ACC_RESET_PW_SUCCESS) {
      this.openModal();
    } else {
      // Reset CAPTCHA, since response can only be validated once
      if (this.state.recaptchaRef) {
        this.state.recaptchaRef.reset();
      }
      this.setBackendErrorMsg();
    }
  };

  render() {
    return (
      <React.Fragment>
        <FemaGoModal
          size="tiny"
          title="Success!"
          open={this.state.modalOpen}
          confirmAction={this.navigateToLogin}
          cancelAction={this.navigateToLogin}
        >
          <p>
            Instructions for resetting your password will be sent to the email address you
            provided if that email address is associated with a FEMA GO account.
          </p>
        </FemaGoModal>

        <AccountWrapper
          title="Forgot your password?"
          guidance="Enter your email below, and we will email you a link to reset your password."
          handleRecaptchaChange={this.handleRecaptchaChange}
          confirmAction={this.handleSubmit}
          cancelAction={this.navigateToLogin}
          disabled={this.state.formHasErrors || this.state.recaptchaToken === emptyStr}
          buttonText="Submit"
        >
          {this.state.backendErrorMsg && (
            <Alert
              header="Error "
              content="There has been an unexpected error. If you continue to recieve this message please contact FEMA for support."
              type="error"
              dismissable={false}
            />
          )}
          <EmailInputForm
            setEmail={this.setEmail}
            setFormHasErrors={this.setFormHasErrors}
          />
        </AccountWrapper>
      </React.Fragment>
    );
  }
}

const emptyStr = '';

export const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (email) => {
      const action = ApiActions.auth.resetPW(email.toLowerCase());
      const response = dispatch(action);
      return response;
    },
    navigateToLogin: () => {
      dispatch(push('/login'));
    },
  };
};

export const mapStateToProps = (state) => {
  return {
    toggles: _.get(state, 'toggles.toggles'),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestPasswordReset);
